import ChartBars from './ChartBars';

export default ChartBars;
